// usersHooks.js - Custom hooks for users functionality
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadUsers, reset } from ".";

export const useUsers = () => {
  const dispatch = useDispatch();
  const users = useSelector((state) => state.users);

  // Load users
  const handleLoadUsers = useCallback(() => {
    return dispatch(loadUsers());
  }, [dispatch]);

  // Reset users state
  const handleReset = useCallback(() => {
    return dispatch(reset());
  }, [dispatch]);

  return {
    // State
    isLoading: users.loading,
    isLoaded: users.loaded,
    isUpdating: users.updating,
    isUpdated: users.updated,
    list: users.list,

    // Actions
    loadUsers: handleLoadUsers,
    reset: handleReset,
  };
};
